<template>
	<div class="advanced-image-wrapper">
		<img
			v-if="!image.mediaType && image.mediaType !== 'video'"
			:src="image.src"
			:alt="image.alt"
			:height="image.height"
			:width="image.width"
		/>
		<video
			v-else
			:src="image.src"
			:alt="image.alt"
			:height="image.height"
			:width="image.width"
			autoplay
			playsinline
			loop
			muted
			preload="metadata"
			disableremoteplayback
		></video>
	</div>
</template>

<script>
export default {
	name: 'AdvancedImage',
	props: {
		image: {
			src: {
				type: String,
				required: true,
			},
			alt: {
				type: String,
				required: true,
			},
		},
	},
};
</script>

<style lang="scss">
.advanced-image-wrapper {
	display: block;
	position: relative;
	overflow: hidden;

	img,
	video {
		display: block;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	video {
		object-fit: contain;
		width: 100%;
		height: auto;
		position: absolute;
		top: 0;
		left: 0;
	}
}
</style>
